<template>
    <div class="app flex-row align-items-center">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-6">
                    <div class="card-group mb-0">
                        <div class="card p-4">
                            <div class="card-body login-container">
                                <form @submit.prevent.stop="submit" v-debounce ref="form">
                                    <p class="mb-3 font-weight-bold">{{ trans('contacts.actions.reset_password') }}</p>
                                    <form-group class="mb-2" :field-parent-classes="'col-12'">
                                        <label slot="label" for="username" class="col-12 col-form-label">{{ trans('contacts.attributes.email_address') }} / {{ trans('contacts.attributes.user_name') }}</label>
                                        <div slot="field" class="input-group">
                                            <span class="input-group-addon"><i class="fa fa-fw fa-at"></i></span>
                                            <input id="username" type="text" class="form-control" ref="focus" v-model="username" autocomplete="off">
                                        </div>
                                    </form-group>
                                    <form-group class="mb-2" :field-parent-classes="'col-12'">
                                        <label slot="label" for="password" class="col-12 col-form-label">{{ trans('auth.password') }}</label>
                                        <div slot="field" class="input-group">
                                            <span class="input-group-addon"><i class="fa fa-fw fa-lock"></i></span>
                                            <input type="password" id="password" class="form-control" v-model="password" autocomplete="off">
                                        </div>
                                    </form-group>
                                    <form-group :field-parent-classes="'col-12'">
                                        <label slot="label" for="password" class="col-12 col-form-label">{{ trans('contacts.attributes.new_password_repetition') }}</label>
                                        <div slot="field" class="input-group">
                                            <span class="input-group-addon"><i class="fa fa-fw fa-lock"></i></span>
                                            <input type="password" id="password_confirmation" class="form-control" v-model="password_confirmation" autocomplete="off">
                                        </div>
                                    </form-group>
                                    <div class="form-group row has-success" v-if="hasSuccessMessage">
                                        <div class="col-12">
                                            <div class="form-control-feedback" v-html="formattedSuccessMessage"></div>
                                        </div>
                                    </div>
                                    <div class="form-group row has-danger" v-if="hasErrorMessages">
                                        <div class="col-12">
                                            <div class="form-control-feedback" v-html="formattedErrorMessage"></div>
                                        </div>
                                    </div>
                                    <div class="form-group row has-danger" v-if="hasValidationMessages">
                                        <div class="col-12">
                                            <div class="form-control-feedback"
                                                 v-html="formattedValidationMessage"></div>
                                        </div>
                                    </div>
                                    <spinner class="mt-4" v-if="state.loading" slot="field"></spinner>
                                    <div class="mt-4">
                                        <button type="submit" class="btn btn-block btn-primary px-4">
                                            {{ trans('contacts.actions.reset_password') }}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import {mapState, mapActions} from 'vuex';

    import Spinner from '@/components/Loaders/Spinner';
    import FormGroup from '@/components/Forms/FormGroupHorizontal';

    import PasswordResetController from '@/services/Auth/PasswordResetController';
    import LoginController from '@/services/Auth/LoginController';

    export default {

        name: 'password-reset',

        components: {Spinner, FormGroup},

        data() {
            return {
                username: null,
                password: null,
                password_confirmation: null,
                state: {
                    loading: false
                }
            };
        },

        created() {
            LoginController.authCheck().then(response => {
                if (response) {
                    // Log out lazy testing users who for some reason don't log out before using this
                    this.logout();
                }
            });
        },

        mounted() {
            this.setPageTitle(this.trans('contacts.actions.reset_password'));
        },

        computed: {

            ...mapState(['messages']),

            hasValidationMessages() {
                return Object.keys(this.messages.validation).length > 0;
            },
            formattedValidationMessage() {
                return Object.keys(this.messages.validation).reduce((acc, field) => {
                    return `${acc}${acc ? '<br>' : ''}${this.messages.validation[field]}`;
                }, '');
            },

            hasSuccessMessage() {
                return this.messages.success !== '';
            },
            formattedSuccessMessage() {
                return this.messages.success;
            },

            hasErrorMessages() {
                return this.messages.error.length > 0;
            },
            formattedErrorMessage() {
                return this.messages.error[0];
            }

        },

        methods: {

            ...mapActions(['resetMessages', 'swalToast', 'logoutAuthUser']),

            logout() {
                this.logoutAuthUser();
            },

            submit() {
                this.formSubmitShowWait(this.$refs.form);

                this.state.loading = true;

                this.resetMessages();

                PasswordResetController.reset(
                    this.username,
                    this.password,
                    this.password_confirmation,
                    this.$route.params.token
                ).then(response => {
                    if (response.success) {
                        this.$router.push({name: 'dashboard.index'});
                        this.swalToast({type: 'success', message: [response.message]});
                    } else {
                        this.swalToast({type: 'error', message: [response.message]});
                    }
                }).finally(() => {
                    this.state.loading = false;
                    this.formSubmitHideWait(this.$refs.form);
                });
            }

        }

    };

</script>



// WEBPACK FOOTER //
// src/views/Auth/PasswordReset.vue